module.exports = require('./helpers/bundle-url').getBundleURL('id8OZ') + "logo-dark.eefe0b7f.svg";